import {BaseManager} from "../../infrastructure/managers/base-manager";
import {CookieUtils} from "../../infrastructure/utils/cookie-utils";
import {DomUtils} from "../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../bootstrap/models/site-config";
import {DeviceStore} from "../app/device.store";
import {COOKIE_NAMES, GA4_COOKIE} from "../consts";
import {LocalDataCookieModel} from "../models/cookies/local-data.cookie.model";
import {UserSettingsCookieModel} from "../models/cookies/user-settings.cookie.model";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class CookieManager extends BaseManager {
  countryId: Number;
  expireDays: Number = 10 * 365; // 10 years
  userSettingsCookie: UserSettingsCookieModel;
  localDataCookie: LocalDataCookieModel;

  static injectables = [...BaseManager.injectables, CookieUtils];

  constructor(
    domUtils: DomUtils,
    loggerUtils: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
    cookieUtils: CookieUtils
  ) {
    super(domUtils, loggerUtils, siteConfig, deviceStore);

    this.cookieUtils = cookieUtils;
    this._initializeCookies();
  }

  _initializeCookies() {
    const localDataCookieString: String = this._getCookieStringByName(COOKIE_NAMES.localData);
    const localDataCookie: Object = JSON.parse(localDataCookieString) || {}
    this.localDataCookie = new LocalDataCookieModel(localDataCookie);

    const userSettingsCookieString: String = this._getCookieStringByName(COOKIE_NAMES.userSettings);
    const userSettingsCookie: Object = JSON.parse(userSettingsCookieString) || {};
    this.userSettingsCookie = new UserSettingsCookieModel(userSettingsCookie);
  }

  _getCookieStringByName(name) {
    return decodeURIComponent(this.cookieUtils.getCookieByName(name));
  }


  updateCookieUserId(userId: String) {
    this._updateCookie(COOKIE_NAMES.userId, userId, true);
  }


  updateCookieLangId(langId: Number) {
    this.userSettingsCookie.selectedLangID = langId;
    this._updateCookie(COOKIE_NAMES.userSettings, this.userSettingsCookie);
  }

  updateCookieUserCountryId(userCountryId: Number) {
    this.localDataCookie.countryId = userCountryId;
    this._updateCookie(COOKIE_NAMES.localData, this.localDataCookie);
  }

  _updateCookie(cookieName, cookie, crossDomain = false) {
    const stringCookie = encodeURIComponent(JSON.stringify(cookie));
    this.cookieUtils.setCookie(cookieName, stringCookie, this.expireDays, crossDomain);
  }

  get ga4ClientId(): String {
    const ga4ClientIdParam: String = this.cookieUtils.getCookieByName(GA4_COOKIE.KEYS.CLIENT_ID);
    let ga4ClientId: String = ga4ClientIdParam?.split('.')?.slice(2, ga4ClientIdParam.length).join('_');
    ga4ClientId = ga4ClientId?.replaceAll(/\./g, "");

    return ga4ClientId;
  }

  get ga4SessionId(): String {
    const ga4SessionIdParams: Array<String> = this.cookieUtils.getCookiesBySubstring(GA4_COOKIE.KEYS.SESSION_ID);
    let ga4SessionId: String = ga4SessionIdParams?.first()?.last()?.split('.')[2];
    ga4SessionId = ga4SessionId?.replaceAll(/\./g, "");

    return ga4SessionId;
  }

  get didomiToken(): String {
    const didomiToken: String = this.cookieUtils.getCookieByName('didomi_token');

    return didomiToken;
  }
}
